// src/components/sensors/SensorCard.js aggiornato
import React from 'react';
import RegularSensorView from '../RegularSensorView';
import LevelSensorView from '../LevelSensorView';
import WeatherSensorView from '../WeatherSensorView';
import SensorChart from '../SensorChart';
import MetricSelector from '../common/MetricSelector';
import { getSensorType } from '../../services/sensorTypesService';

const SensorCard = ({
  sensor,
  sensorStats,
  chartData,
  displayedMetrics,
  handleMetricChange,
  availableMetrics,
  getSensorDisplayName,
  isExpanded,
  toggleExpandCard,
  formatItalianTime,
  dataAggregation,
  isLoading
}) => {
  const sensorType = getSensorType(sensor);
  
  return (
    <div 
      className={`card shadow-sm h-100 ${isExpanded ? 'border-primary' : ''} ${
        sensorStats?.isActive === false ? 'border-danger' : ''
      }`}
    >
      {/* Header della card */}
      <div className={`card-header py-2 px-3 d-flex justify-content-between align-items-center ${
        sensorStats?.isActive === false ? 'bg-danger bg-opacity-10' : ''
      }`}>
        <div className="d-flex align-items-center">
          <h3 className="fs-5 fw-bold mb-0">
            {getSensorDisplayName(sensor)}
          </h3>
          {sensorStats?.isActive === false && (
            <span className="badge bg-danger ms-2" title="Nessun aggiornamento da più di 30 minuti">
              <i className="bi bi-exclamation-triangle"></i> Inattivo
            </span>
          )}
        </div>
        <button 
          className="btn btn-sm btn-link text-muted p-0" 
          onClick={() => toggleExpandCard(sensor)}
          aria-label={isExpanded ? "Comprimi" : "Espandi"}
        >
          <i className={`bi ${isExpanded ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
        </button>
      </div>
      
      {/* Corpo della card con informazioni attuali */}
      <div className="card-body p-3 position-relative">
        {/* Overlay di caricamento */}
        {isLoading && (
          <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
               style={{backgroundColor: "rgba(255,255,255,0.85)", zIndex: 100, borderRadius: "0 0 0.5rem 0.5rem"}}>
            <div className="d-flex flex-column align-items-center">
              <div className="spinner-border text-primary mb-2" role="status">
                <span className="visually-hidden">Caricamento...</span>
              </div>
              <span>Caricamento dati...</span>
            </div>
          </div>
        )}
        
        {/* Contenuto specifico per tipo di sensore */}
        {sensorType === 'level' ? (
          <LevelSensorView sensorStats={sensorStats} />
        ) : sensorType === 'weather' ? (
          <WeatherSensorView sensorStats={sensorStats} />
        ) : (
          <RegularSensorView sensorStats={sensorStats} />
        )}
        
{/* Informazioni ultimo aggiornamento - CORREZIONE */}
<div className="small text-muted mb-3">
  Ultimo aggiornamento: {sensorStats?.lastUpdateTime 
    ? formatItalianTime(sensorStats.lastUpdateTime, 'dd/MM/yyyy HH:mm:ss')
    : 'N/A'
  }
</div>
        
        {/* Grafici - mostrati solo se la card è espansa */}
        {isExpanded && (
          <>
            {/* Selettore metriche per la stazione meteo */}
            {sensorType === 'weather' && (
              <div className="mb-3 p-2 bg-light rounded">
                <div className="d-flex flex-wrap gap-1">
                  {availableMetrics.map(metric => (
                    <button
                      key={metric.id}
                      onClick={() => handleMetricChange(metric.id)}
                      className={`btn btn-sm rounded-pill ${
                        displayedMetrics.includes(metric.id)
                          ? 'btn-primary'
                          : 'btn-outline-secondary'
                      }`}
                      style={{fontSize: '0.75rem'}}
                    >
                      <i className={`bi ${displayedMetrics.includes(metric.id) ? 'bi-eye' : 'bi-eye-slash'} me-1`}></i>
                      {metric.label}
                    </button>
                  ))}
                </div>
              </div>
            )}
            
            <SensorChart 
              sensor={sensor}
              chartData={chartData}
              sensorType={sensorType}
              displayedMetrics={displayedMetrics}
              dataAggregation={dataAggregation}
              formatItalianTime={formatItalianTime}
            />
          </>
        )}
        
        {/* Pulsante espandi per mobile */}
        {!isExpanded && (
          <div className="text-center mt-1">
            <button 
              className="btn btn-sm btn-outline-secondary px-4 rounded-pill"
              onClick={() => toggleExpandCard(sensor)}
            >
              Espandi dettagli <i className="bi bi-chevron-down ms-1"></i>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SensorCard;